function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-37.5%",
  y: "-17.6%",
  width: "175%",
  height: "152.9%",
  filterUnits: "objectBoundingBox",
  id: "map-pin-selected_svg__a"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 6,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M24 68c3.483 0 24-30.745 24-44C48 10.745 37.255 0 24 0S0 10.745 0 24s20.517 44 24 44z",
  id: "map-pin-selected_svg__b"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  fillOpacity: 1,
  filter: "url(#map-pin-selected_svg__a)",
  xlinkHref: "#map-pin-selected_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M24 1A22.928 22.928 0 007.737 7.737 22.928 22.928 0 001 24c0 5.445 3.582 13.89 7.934 21.868 3.006 5.512 6.398 10.802 9.308 14.754C20.898 64.23 23.062 67 24 67c.939 0 3.102-2.771 5.758-6.378 2.91-3.952 6.302-9.242 9.308-14.754C43.418 37.89 47 29.445 47 24a22.928 22.928 0 00-6.737-16.263A22.928 22.928 0 0024 1z"
}));

function SvgMapPinSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 58,
    height: 76,
    viewBox: "-4 0 58 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default SvgMapPinSelected;